import React, { useEffect, useState } from "react";
import { ModalDetalle } from "./ModalDetalle";
import { Estados } from "../Otros/Estados";
import { listarDerivaciones } from "../../utils/Datos";
import { Alerta } from "../Otros/Alerta";
import { LoadingSpinner } from "../Otros/LoadingSpinner";
import { fechaHumana } from "../../utils/Util";

export const Derivaciones = ({ id_request_neighbor, titulo }) => {
  const [cargando, setcargando] = useState(true);
  const [derivaciones, setderivaciones] = useState([]);
  const [idDerivacion, setIdDerivacion] = useState([]);

  useEffect(() => {
    listarDerivaciones(id_request_neighbor).then((respuesta) => {
      setcargando(false);
      if (respuesta.status) {
        setderivaciones(respuesta.datos);
      }
    });
  }, [id_request_neighbor]);

  return (
    <>
      <h4 className="text-gray-700 mt-8">DERIVACIONES</h4>
      <div className="w-100 d-flex flex-stack mb-5 row">
        <div className="col-md-2 col-sm-12 ps-55">
          <i
            className="ki-duotone ki-note-2 opacity-50"
            style={{ fontSize: "9em" }}
          >
            <span className="path1"></span>
            <span className="path2"></span>
            <span className="path3"></span>
            <span className="path4 text-primary opacity-75"></span>
            <span className="path5 text-primary opacity-75"></span>
          </i>
        </div>

        <div className="col-md-10 col-sm-12">
          <div className="table-responsive">
            {cargando ? (
              <LoadingSpinner
                texto={`Cargando derivaciones...`}
              ></LoadingSpinner>
            ) : derivaciones.length > 0 ? (
              <table className="table align-middle table-row-bordered mb-0 gy-5">
                <tbody className="fw-semibold text-gray-600">
                  {derivaciones.map((derivacion, index) => {
                    return (
                      <tr key={`tr_${index}`}>
                        <td className="fw-bold">
                          <div className="d-flex align-items-center">
                            <i className="ki-duotone ki-calendar fs-2 me-2">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                            <span className="">
                              {derivacion.direction_name}
                            </span>
                          </div>
                        </td>
                        <td className="fw-bold">
                          <Estados estado={derivacion.status_derivation} />
                          {derivacion.status_derivation == "RESUELTA" ? (
                            <span className="text-muted ms-4">
                              <ModalDetalle
                                titulo={titulo}
                                onClick={() => {
                                  console.log(
                                    "derivacion.id_derivation ",
                                    derivacion.id_derivation
                                  );
                                  setIdDerivacion(derivacion.id_derivation);
                                }}
                                id_derivacion={idDerivacion}
                              ></ModalDetalle>
                            </span>
                          ) : (
                            <></>
                          )}
                        </td>
                        <td className="text-muted">
                          Derivado el {fechaHumana(derivacion.creation_date)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <Alerta
                tipo={`info`}
                titulo={`Información`}
                texto={`Aún no hay derivaciones para mostrar en esta solicitud`}
              ></Alerta>
            )}
          </div>
        </div>

        <div className="m-0"></div>
      </div>
    </>
  );
};
